export default __webpack_public_path__ + "static/wwu-4-09df1c1b9952fb550cf40237bb500eff.png";